import * as React from "react"

const SvgComponent = (props) => (
    <svg width={512} height={512} {...props}
         viewBox={'0 0 512 512'}>
        <path
            stroke={"#F72585"}
            fill={"#F72585"}


            d="M448 304c-18 0-32-14-32-32s14-32 32-32 32 14 32 32-14 32-32 32zm0-48c-9 0-16 7-16 16s7 16 16 16 16-7 16-16-7-16-16-16zM176 64c-18 0-32-14-32-32s14-32 32-32 32 14 32 32-14 32-32 32zm0-48c-9 0-16 7-16 16s7 16 16 16 16-7 16-16-7-16-16-16zm144 416c-18 0-32-14-32-32s14-32 32-32 32 14 32 32-14 32-32 32zm0-48c-9 0-16 7-16 16s7 16 16 16 16-7 16-16-7-16-16-16zM56 280c-18 0-32-14-32-32s14-32 32-32 32 14 32 32-14 32-32 32zm0-48c-9 0-16 7-16 16s7 16 16 16 16-7 16-16-7-16-16-16zm97-188 14 8-96 176-14-8zm273 239 12 10-88 96-12-10zm86 229H0v-64h512zM16 496h480v-32H16zM200 45l112 328-16 6L184 51z" />
    </svg>
)

export default SvgComponent
